import { ApplicationCaseSummaryDto } from './application-case-summary-dto.model';

export class BaseApplicationCaseDetailsDto extends ApplicationCaseSummaryDto {
  public ApplicationID: string;
  public ApplicationNumber?: number;
  public ApplicationTypeCode: string;
  public IsAutoPackagingEnabled: boolean;
  public IsQualifiedForPackaging?: boolean;
  public WasPackagingGenerated?: boolean;
  public WasPackagingPublished?: boolean;
  public WasLastMortgageApplicationAccepted?: boolean;
  public IsCaseLockedForExternalUser: boolean;
  public PropertyPostcode: string;
  public WasMaterialChangeApplied?: boolean;
  public SamLatestStatusCode: string;
  public CaseType: string;
  public ProductName: string;
  public BorrowingTermYears?: number;
  public LTV?: number;
  public StatusCode: string;
  public IsForAdvice?: boolean;
}
